import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LanguageDto } from '../types/language';
import { RootState } from './store';
import LanguageProvider from "../services/languageProvider";

type LanguageDataStatus = 'idle' | 'loading' | 'failed';

const sliceName = 'language';
interface LanguageState {
    languages: LanguageDto[] | null;
    languagesStatus: LanguageDataStatus;
}
const initialState: LanguageState = {
    languages: null,
    languagesStatus: 'idle',
};
export const fetchLanguages = createAsyncThunk<LanguageDto[], void, unknown>(
    `${sliceName}/fetchLanguages`,
    async () => {
        return await LanguageProvider.getLanguages();
    },
);

const languageSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {},
    extraReducers: builder => {
    builder
        .addCase(fetchLanguages.pending, state => {
            state.languagesStatus = 'loading';
        })
        .addCase(fetchLanguages.fulfilled, (state, action) => {
            state.languages = action.payload;
            state.languagesStatus = 'idle';
        })
        .addCase(fetchLanguages.rejected, state => {
            state.languagesStatus = 'failed';
        });
    },
});
export const selectLanguages = (state: RootState) => state.language.languages;
export const selectLanguagesStatus = (state: RootState) => state.language.languagesStatus;

export default languageSlice.reducer;
